import React from 'react';
import styled from '@emotion/native';
import { useRouter } from 'expo-router';
import { MobileMenuItem } from '@/shared/types/navigation';
import { accent, green, mint } from '@/shared/styles/colors';
import { Icon } from 'react-native-paper';
import { BodyText } from '@/shared/components/StyledText';
import { useApollo } from '@/services/apollo/ApolloProvider';

interface MobileDrawerItemProps extends MobileMenuItem {
  isActive: boolean;
  isLast: boolean;
}

const MobileDrawerItem = ({
  label,
  route,
  leadingIcon,
  trailingIcon,
  isActive,
  isLast,
}: MobileDrawerItemProps) => {
  const router = useRouter();
  const { logOut } = useApollo();

  const handlePress = async () => {
    if (route === 'logout') {
      logOut();
    } else if ('action' in route) {
      route.action();
    } else {
      router.push(route.path);
    }
  };

  return (
    <ItemContainer onPress={handlePress} isActive={isActive} isLast={isLast}>
      <IconContainer>
        <Icon
          source={leadingIcon.source}
          size={leadingIcon.size ?? 24}
          color={green}
        />
      </IconContainer>
      <Label isActive={isActive}>{label}</Label>
      {trailingIcon && (
        <TrailingIconContainer>
          <Icon source={trailingIcon.source} size={trailingIcon.size ?? 24} />
        </TrailingIconContainer>
      )}
    </ItemContainer>
  );
};

export default MobileDrawerItem;

const ItemContainer = styled.TouchableOpacity<{
  isActive?: boolean;
  isLast: boolean;
}>(({ isActive, isLast }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  paddingTop: 14,
  paddingBottom: 18,
  paddingRight: 30,
  paddingLeft: 28,
  backgroundColor: isActive ? accent : 'transparent',
  borderBottomColor: mint,
  borderBottomWidth: isLast ? 0 : 1,
  minHeight: 68,
}));

const IconContainer = styled.View({
  marginRight: 10,
});

const Label = styled(BodyText)<{ isActive: boolean }>(({ isActive }) => ({
  fontWeight: isActive ? 'bold' : 'normal',
  flex: 1,
  color: green,
}));

const TrailingIconContainer = styled.View({
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 34.5,
});
